import { invalidateItemQueries } from '@/shared/api/invalidate-item-queries';
import { trpc } from '@/shared/api/trpc';

export const useUpdateTravellersContactInfo = () => {
  const utils = trpc.useUtils();
  return trpc.operations.updateTravellersContactInfo.useMutation({
    onSettled: () => invalidateItemQueries(utils),
  });
};
